import { render, staticRenderFns } from "./insertTransaction.vue?vue&type=template&id=0f02c0b6&scoped=true&"
import script from "./insertTransaction.vue?vue&type=script&lang=js&"
export * from "./insertTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02c0b6",
  null
  
)

export default component.exports